import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Constants } from 'src/app/shared/constants';
import { Services } from 'src/app/types/filter-config';

@Component( {
    selector: 'riege-service-selector',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatCheckboxModule],
    templateUrl: './service-selector.component.html',
    styleUrl: './service-selector.component.scss',
    standalone: true
} )
export class ServiceSelectorComponent {
    @Input() selectedServices!: Services;

    @Output() servicesSelected = new EventEmitter();

    private readonly fb = inject( FormBuilder );
    readonly services = this.fb.group( {} );

    serviceFilter!: Services;

    readonly serviceDefs = Constants.services;

    /** contruct selector option from constants */
    constructor() {
        this.serviceDefs.forEach( def => {
            this.services.addControl( def.id, new FormControl( false ) );
        } );
    }

    ngOnInit() {
        if ( this.selectedServices ) {
            // keep a copy for reset
            this.serviceFilter = { ...this.selectedServices };

            this.services.patchValue( this.selectedServices );
        }
    }

    /**
     * keeps track of changes on form values
     * selected services are reset to inital filter setting
     * when filter controls reset button is clicked
     */
    ngOnChanges(): void {
        const servicesChanged = JSON.stringify( this.selectedServices ) === JSON.stringify( this.serviceFilter );
        if ( servicesChanged ) {
            this.services.patchValue( this.serviceFilter );
        }
    }

    /** pass selected services to service */
    selectionChanged() {
        this.servicesSelected.emit( this.services.value );
    }
}
